module.exports = __webpack_public_path__ + "img/main-banner-mobile-690.2d531d40.jpg";